module.exports = __webpack_public_path__ + "static/media/mobile_background.25fcbe59.png";